// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__s_EeG","logo":"header_logo__5D8GC","right":"header_right__0fZTX","title":"header_title__c6Ki9"};